import React, { useState, useRef, useEffect } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Close } from "@mui/icons-material";

import { useClickOutside } from "hooks";
import { setVisibleCalendar, setSelectedDate, getAvailableDates, getHeaderBgColor, getSelectedDate } from "slices";

import TopBox from "./TopBox";
import DayShow from "./DayShow";
import MonthShow from "./MonthShow";
import YearShow from "./YearShow";

const CalendarBox = () => {
  const dispatch = useDispatch();
  const availableDates = useSelector(getAvailableDates);
  const backgroundColor = useSelector(getHeaderBgColor);

  const [focusedDate, setFocusedDate] = useState(moment());
  const [showType, setShowType] = useState("day");
  const selectedDate = useSelector(getSelectedDate);

  const calendarRef = useRef(null);

  useEffect(() => {
    if (availableDates.length) {
      setFocusedDate(moment(availableDates[0]) || moment());
    }
  }, [availableDates]);

  const onClickDate = (date) => {
    dispatch(setSelectedDate(date.format("MMM DD, YYYY")));

    setTimeout(() => {
      dispatch(setVisibleCalendar(false));
    }, 1);
  };

  const onClickMonth = (idx) => {
    setFocusedDate(focusedDate.clone().month(idx));
    setShowType("day");
  };

  const onClickYear = (year) => {
    setFocusedDate(focusedDate.clone().year(year));
    setShowType("day");
  };

  useClickOutside(calendarRef, () => {
    dispatch(setVisibleCalendar(false));
  });

  return (
    <div className="modal-shadow hayley-absolute hayley-bottom-0 hayley-top-0 hayley-z-30 hayley-flex hayley-h-full hayley-w-full hayley-items-center hayley-justify-center hayley-bg-[#333333CC]">
      <div
        className="hayley-grid hayley-h-fit hayley-w-fit hayley-select-none hayley-grid-cols-7 hayley-rounded-[4px] hayley-border hayley-border-solid hayley-border-custom-6 hayley-bg-white hayley-p-4"
        ref={calendarRef}
      >
        <div className="hayley-col-span-7 -hayley-m-2 hayley-flex hayley-h-5 hayley-min-w-[252px] hayley-items-center hayley-justify-end hayley-align-middle ">
          <Close
            onClick={() => {
              dispatch(setVisibleCalendar(false));
            }}
            className="hayley-right-1 hayley-top-4 hayley-z-50 hayley-h-4 hayley-w-4 hayley-cursor-pointer"
            sx={{ "&:hover": { color: `${backgroundColor} !important` } }}
          />
        </div>
        <TopBox focusedDate={focusedDate} showType={showType} setFocusedDate={setFocusedDate} setShowType={setShowType} />
        {showType === "day" && <DayShow selectedDate={selectedDate} focusedDate={focusedDate} onClickDate={onClickDate} />}
        {showType === "month" && <MonthShow selectedDate={selectedDate} onClickMonth={(idx) => onClickMonth(idx)} />}
        {showType === "year" && <YearShow onClickYear={(year) => onClickYear(year)} />}
      </div>
    </div>
  );
};

export default CalendarBox;
